import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MySickLeavePage from './pages/MySickLeavePage';
import MySickLeaveDetailPage from './pages/MySickLeaveDetailPage';

const MySickLeaveModule: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<MySickLeavePage />} />
      <Route path="/:applicationId" element={<MySickLeaveDetailPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default MySickLeaveModule;
